<template>
  <div>
    <el-form
      label-position="left"
      label-width="150px"
      ref="localRecipient"
      :model="localRecipient"
      :rules="rules"
    >
      <el-form-item label="Email" prop="email">
        <el-autocomplete
          clearable
          class="inline-input"
          style="width:100%"
          v-model="localRecipient.email"
          :fetch-suggestions="querySearch"
          placeholder="Email Address"
          @clear="clearForm"
          @select="handleSelect"
        >
          <template slot-scope="{ item }">
            <div class="value">{{ item.email }}</div>
          </template>
        </el-autocomplete>
      </el-form-item>

      <el-form-item label="Name" prop="firstName">
        <el-input v-model="localRecipient.firstName" placeholder="First Name"></el-input>
      </el-form-item>

      <el-form-item label="Surname" prop="lastName">
        <el-input v-model="localRecipient.lastName" placeholder="Surname"></el-input>
      </el-form-item>

      <el-form-item v-if="companies.length" label="Company" prop="companyId" required>
         <el-select 
          class="full-width" 
          :clearable="true" 
          :filterable="true" 
          v-model="localRecipient.companyId">
          <el-option
            v-for="company in companies"
            :key="company.id"
            :label="company.title"
            :value="parseInt(company.id)"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="Reports">
        <div>
          <el-checkbox
            size="small"
            v-model="localRecipient.campaignSummary"
            label="Campaign Summary"
            border
          ></el-checkbox>
          <br />
          <el-checkbox
            size="small"
            v-model="localRecipient.surveySummary"
            label="Survey Summary"
            border
          ></el-checkbox>
          <br />
          <el-checkbox
            size="small"
            v-model="localRecipient.programmingSummary"
            label="Programming Summary"
            border
          ></el-checkbox>
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer clearfix">
      <span class="pull-right">
        <el-button id="cancel" type="danger" @click="cancel" plain>Cancel</el-button>
        <el-button id="save" type="primary" :loading="savingRecipient" @click="handleFormSave" plain
          >Save</el-button
        >
      </span>
    </span>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { omit } from 'lodash';
import createRecipientMutation from '@/graphql/automatedemails/recipients/createRecipient.gql';
import updateRecipientMutation from '@/graphql/automatedemails/recipients/updateRecipient.gql';

export default {
  name: 'RecipientManage',
  props: {
    recipient: {
      type: Object,
      required: true,
    },
    users: {
      type: Array,
      default: () => ([]),
    },
    companies: {
      type: Array,
      default: () => ([]),
    },
    me: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    savingRecipient: false,
    localRecipient: {},
    rules: {
      email: [{ required: true, message: 'Please provide an email address' }],
      firstName: [{ required: true, message: 'Please provide a name' }],
      lastName: [{ required: true, message: 'Please provide a surname' }],
      companyId: [{ required: true, message: 'Please select a company' }],
    },
  }),

  mounted() {
    /**
     * Deep copy user for for the form so that state is not directly mutated in child component
     */
    this.localRecipient = { ...this.recipient };
  },

  computed: {
    ...mapState('user', ['updateCompanyUserRequest', 'updateCompanyUserSucceeded']),
  },

  methods: {
    handleFormSave() {
      this.$refs.localRecipient.validate(valid => {
        if (valid) return this.saveRecipient();
        return false;
      });
    },

    async saveRecipient() {
      this.savingRecipient = true;
      const recipient = omit(this.localRecipient, 'company');

      if ('id' in recipient) {
        const { id, ...data } = recipient;
        await this.$apollo.mutate({
          client: 'apiv2',
          mutation: updateRecipientMutation,
          variables: { id: parseInt(id, 10), data },
        });
      } else {
        await this.$apollo.mutate({
          client: 'apiv2',
          mutation: createRecipientMutation,
          variables: { data: recipient },
        });
      }
      this.savingRecipient = false;
      this.$emit('saved');
    },

    cancel() {
      this.$emit('cancelled');
    },

    handleSelect(user) {
      this.localRecipient.email = user.email;
      this.localRecipient.firstName = user.firstName;
      this.localRecipient.lastName = user.lastName;
      this.localRecipient.companyId = parseInt(user.company.id, 10);
    },

    clearForm() {
      this.$refs.localRecipient.resetFields();
    },

    querySearch(queryString, cb) {
      const users = this.users;

      const results = queryString
        ? users.filter(user => user.email.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        : users;
      cb(results);
    },
  },

  watch: {
    updateCompanyUserRequest(val, oldVal) {
      if (val !== oldVal && val) {
        this.savingUser = true;
      }

      if (!val) {
        this.savingUser = false;
        this.$emit(this.updateCompanyUserSucceeded ? 'saved' : 'saveError', this.user);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// RecipientManage.vue?4d640d02